// Lightweight logger with environment gating
// - debug/info: disabled in production by default
// - warn/error: always enabled
// - enable verbose logs by setting localStorage.setItem('debugLogs','true') or REACT_APP_DEBUG=true

const getMode = () => {
  try {
    // Support Vite and CRA
    // eslint-disable-next-line no-undef
    const viteMode = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.MODE;
    const craMode = typeof process !== 'undefined' && process.env && process.env.NODE_ENV;
    return viteMode || craMode || 'production';
  } catch {
    return 'production';
  }
};

const isDebugEnabled = () => {
  try {
    const ls = (typeof window !== 'undefined' && window.localStorage) ? window.localStorage.getItem('debugLogs') : null;
    const env = typeof process !== 'undefined' && process.env && (process.env.REACT_APP_DEBUG || process.env.DEBUG);
    const mode = getMode();
    return ls === 'true' || env === 'true' || env === '1' || mode === 'development';
  } catch {
    return false;
  }
};

let globalSilenceErrors = false;

export const setGlobalErrorSilence = (silence) => { globalSilenceErrors = !!silence; };

const makeLogger = () => {
  const debugOn = isDebugEnabled();
  return {
    debug: (...args) => { if (debugOn && typeof console !== 'undefined' && console.debug) console.debug(...args); },
    info: (...args) => { if (debugOn && typeof console !== 'undefined' && console.info) console.info(...args); },
    warn: (...args) => { if (typeof console !== 'undefined' && console.warn) console.warn(...args); },
    error: (...args) => { if (!globalSilenceErrors && typeof console !== 'undefined' && console.error) console.error(...args); },
  };
};

const logger = makeLogger();
export default logger;
